import styled from 'styled-components';


export const SuccessMsgWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        padding: ${props.theme.spacing.large.l30} ${props.theme.spacing.nospacing};
        line-height:${props.theme.font.lineHeight.large};
        align-items: flex-start;
        justify-content: flex-start;
        text-align:center;
        flex-direction: column;
        height: 50rem;
    `,
)

export const VerificationHeadText = styled.p(
    props =>`
    width: 100%;
    display: flex;
    font-size: ${props.theme.font.large.font28};
    color: ${props.theme.colors.blue.dark};
    font-weight: ${props.theme.font.fontWeight.black};
`);

export const VerificationInnerWrapper = styled.div(
    props =>`
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: ${props.theme.spacing.large.l40} ${props.theme.spacing.nospacing};
`);

export const InfoInnerText = styled.p(
    props =>`
    display: block;
    font-size: ${props.theme.font.large.font21};
    color: ${props.theme.colors.black.base};
    line-height: ${props.theme.font.lineHeight.large};
    text-align: ${props.theme.font.textAlign.left};
`);

export const InfoInnerTextWrap = styled.p(
    props =>`
    display: block;
    font-size: ${props.theme.font.large.font21};
    color: ${props.theme.colors.black.base};
    line-height: ${props.theme.font.lineHeight.large};
    padding-top:${props.theme.spacing.large.l30};
    text-align: ${props.theme.font.textAlign.left};
`);